/* Chula — wishlist drawer
 *
 * Extracted from snippets/chula-wishlist-drawer.liquid on 2026-09-20: 27 KB
 * that shipped inline on every page and could never be cached. Strings,
 * routes, currency, crest markup and signed-in state arrive from the
 * #chula-wishlist-config JSON island rendered beside it.
 */

(function () {
    /* Everything Liquid used to interpolate into this script now arrives as
       JSON from the island rendered beside it — a .js asset is served
       verbatim, so no Liquid runs inside one. `signedIn` is per-visitor and
       therefore belongs in the island (inline HTML), never in the asset. */
    var CFG = (function () {
      var node = document.getElementById('chula-wishlist-config');
      try { return node ? JSON.parse(node.textContent) : {}; } catch (e) { return {}; }
    })();
    if (!CFG.i18n) CFG.i18n = {};
    var drawer = document.getElementById('chula-wishlist-drawer');
    if (!drawer || drawer.dataset.chulaWlReady) return;
    drawer.dataset.chulaWlReady = '1';

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    var body = drawer.querySelector('[data-chula-wl-body]');
    var currency = CFG.currency;
    var cache = {};

    // Locale-aware root ('' on the default locale, '/es' etc. elsewhere) so
    // links keep the visitor in her language and product .js fetches come
    // back with translated titles.
    var root = (CFG.rootUrl || '/').replace(/\/$/, '');
    var allUrl = CFG.allProductsUrl;

    // Prefix a path with the locale root unless it already carries it.
    function loc(url) {
      if (!root || url.indexOf(root + '/') === 0) return url;
      return root + url;
    }

    var i18n = CFG.i18n;

    /* Handles whose product page offers "Request this piece" instead of a
       basket — supplied by the Liquid island (see the note there on why the
       suffix, not the collection, is the test). The `request` TAG is kept as a
       second route for anything commissioned that sits outside the Art
       collection. */
    var REQUEST_HANDLES = {};
    (CFG.requestHandles || []).forEach(function (handle) {
      if (handle) REQUEST_HANDLES[handle] = true;
    });

    function isRequestPiece(product) {
      if (!product) return false;
      if (REQUEST_HANDLES[product.handle]) return true;
      return (product.tags || []).some(function (tag) {
        return String(tag).toLowerCase() === 'request';
      });
    }

    /* The wishlist belongs to an account, not to a browser. Signed out, the
       drawer shows the benefits panel instead of a list — see renderRegister
       below and the note in chula-wishlist.liquid about what this does NOT
       do (there is no cross-device sync without an app). */
    var signedIn = CFG.signedIn === true;
    var loginUrl = CFG.loginUrl;

    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function thumb(url) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=500';
    }

    function updateCounts() {
      var count = window.chulaWishlist ? window.chulaWishlist.count() : 0;
      var nodes = document.querySelectorAll('[data-chula-wish-count]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = count > 0 ? count : '';
        nodes[i].style.display = count > 0 ? '' : 'none';
      }
    }

    function renderEmpty() {
      body.innerHTML =
        '<div class="chula-wl__empty">' +
        '<p>' + esc(i18n.empty) + '</p>' +
        '<a href="' + esc(allUrl) + '">' + esc(i18n.discover) + '</a>' +
        '</div>';
    }

    /* `on_success=force_open_drawer` is what makes Prestige open the cart
       drawer on add (theme.js:4493). It does not close anything, which is
       why this drawer closes itself on cart:change further down. */
    function addForm(variantId) {
      return '<product-form>' +
        '<form action="/cart/add" method="post" enctype="multipart/form-data">' +
        '<input type="hidden" name="on_success" value="force_open_drawer">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<input type="hidden" name="id" value="' + esc(variantId) + '">' +
        '<button type="submit" class="chula-wl__action">' + esc(i18n.addToCart) + '</button>' +
        '</form>' +
        '</product-form>';
    }

    function hint() {
      return '<span class="chula-wl__hint">' + esc(i18n.selectSize) + '</span>';
    }

    /* Notify is a link to the product page carrying ?notify=<variant>, not a
       modal opened here. chula-notify-modal.liquid renders from
       product-info.liquid and is bound to ONE product at render time (its
       chips, image and title all come from `product`), so there is no
       instance of it on a collection or cart page for this drawer to open.
       The product page picks the parameter up and fires the existing
       chula:notify:open event with this exact variant — same event, same
       payload shape the PDP already uses, so the Klaviyo path is untouched. */
    function notifyLink(url, variantId) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return '<a class="chula-wl__action" href="' + esc(url + sep + 'variant=' + variantId + '&notify=' + variantId) + '">' +
        esc(i18n.notify) + '</a>';
    }

    /* Picking a value decides what the action under it can be: a
       buyable combination can be added, a sold-out one can only be waited
       for. With two rows on screen the action stays a hint until BOTH have
       a pick — offering "Add to basket" on a half-chosen combination is a
       button that cannot mean anything yet. */
    function readJson(el, attr, fallback) {
      try { return JSON.parse(el.getAttribute(attr)); } catch (e) { return fallback; }
    }

    function paintItem(item) {
      var act = item.querySelector('[data-wl-act]');
      if (!act) return;

      var varying = readJson(item, 'data-opts', []);
      var vs = readJson(item, 'data-variants', []);

      /* Current pick per option position, or null where nothing is chosen. */
      var chosen = {};
      varying.forEach(function (oi) {
        var on = item.querySelector('[data-wl-opt="' + oi + '"][aria-pressed="true"]');
        chosen[oi] = on ? on.getAttribute('data-value') : null;
      });

      /* Grey a value when it cannot be bought ALONGSIDE the picks in the
         other rows — carmine may exist in S and be gone in M, and the row
         has to say so once M is chosen. */
      varying.forEach(function (oi) {
        item.querySelectorAll('[data-wl-opt="' + oi + '"]').forEach(function (b) {
          var val = b.getAttribute('data-value');
          var buyable = vs.some(function (v) {
            if (!v.a || v.o[oi] !== val) return false;
            return varying.every(function (oj) {
              return oj === oi || !chosen[oj] || v.o[oj] === chosen[oj];
            });
          });
          b.classList.toggle('chula-wl__size--out', !buyable);
        });
      });

      var complete = varying.every(function (oi) { return !!chosen[oi]; });
      if (!complete) { act.innerHTML = hint(); return; }

      var match = vs.filter(function (v) {
        return varying.every(function (oi) { return v.o[oi] === chosen[oi]; });
      })[0];

      if (!match) { act.innerHTML = hint(); return; }

      act.innerHTML = match.a
        ? addForm(match.id)
        : notifyLink(item.getAttribute('data-url'), match.id);
    }

    body.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-wl-size]');
      if (!btn) return;
      event.preventDefault();

      var item = btn.closest('[data-wl-item]');
      if (!item) return;

      /* Selection is per row, so only clear the row this button belongs to. */
      var oi = btn.getAttribute('data-wl-opt');
      item.querySelectorAll('[data-wl-opt="' + oi + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      paintItem(item);
    });

    /* Line icons at 1.1px on a 22px box, drawn to sit on the same optical
       weight as the heart in the panel bar above — anything heavier reads
       as UI furniture rather than as a mark beside a sentence. */
    var ICONS = {
      wishlist:
        '<path d="M11 19.2S3.3 13.9 3.3 9a4.2 4.2 0 0 1 7.7-2.3A4.2 4.2 0 0 1 18.7 9c0 4.9-7.7 10.2-7.7 10.2Z"/>',
      addresses:
        '<path d="M11 20s6.4-5.1 6.4-10.2A6.4 6.4 0 0 0 4.6 9.8C4.6 14.9 11 20 11 20Z"/>' +
        '<circle cx="11" cy="9.6" r="2.4"/>',
      orders:
        '<path d="M3.6 7.3 11 3.6l7.4 3.7v7.4L11 18.4l-7.4-3.7Z"/>' +
        '<path d="M3.6 7.3 11 11l7.4-3.7M11 11v7.4"/>'
    };

    function icon(name) {
      return '<svg class="chula-wl__benefit-icon" viewBox="0 0 22 22" width="22" height="22"' +
        ' aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.1"' +
        ' stroke-linecap="round" stroke-linejoin="round">' + ICONS[name] + '</svg>';
    }

    function renderRegister() {
      body.innerHTML =
        '<div class="chula-wl__register">' +
        /* One group, read top to bottom: mark, the sentence, what you get, the
           way in. The benefits sit between the title and the button because
           they are the argument FOR pressing it — putting the action last
           means she reads the case and then finds the control. */
        '<div class="chula-wl__lede">' +
        CFG.logoMarkup +
        '<p class="chula-wl__register-title">' + esc(i18n.registerTitle) + '</p>' +
        '<ul class="chula-wl__benefits">' +
        '<li>' + icon('wishlist') + '<span>' + esc(i18n.registerWishlist) + '</span></li>' +
        '<li>' + icon('addresses') + '<span>' + esc(i18n.registerAddresses) + '</span></li>' +
        '<li>' + icon('orders') + '<span>' + esc(i18n.registerOrders) + '</span></li>' +
        '</ul>' +
        '<a class="chula-wl__signin" href="' + esc(loc(loginUrl)) + '">' + esc(i18n.signInCta) + '</a>' +
        '</div>';
    }

    /* Signed out with nothing saved. The same block the foot of the panel
       carries once she HAS a list — same mark, same offer, same button — a
       step larger and centred in the body, because with no list under it
       this is the panel rather than a note beneath one.

       renderRegister above (the Loewe-style benefits panel) is what used to
       hold this state. It is left in place deliberately: an unreferenced
       function ships zero bytes to a visitor, and removing the benefits
       composition is a merchant decision, not a drive-by one. */
    function renderSaveEmpty() {
      body.innerHTML =
        '<div class="chula-wl__save chula-wl__save--center">' +
        CFG.logoMarkup +
        '<div class="chula-wl__save-copy">' +
        '<p class="chula-wl__save-title">' + esc(i18n.emptyTitle) + '</p>' +
        '<p class="chula-wl__save-text">' + esc(i18n.savePromptShort) + '</p>' +
        '</div>' +
        '<a class="chula-wl__signin" href="' + esc(loc(loginUrl)) + '">' + esc(i18n.signInCta) + '</a>' +
        '</div>';
    }

    var savePrompt = drawer.querySelector('[data-chula-wl-save]');
    var saveToggle = drawer.querySelector('[data-chula-wl-save-toggle]');
    var savePanel = drawer.querySelector('#chula-wl-save-panel');
    var SAVE_COLLAPSED = 'chulaWlSaveCollapsed';

    function setSaveCollapsed(collapsed) {
      if (!saveToggle || !savePanel) return;

      saveToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');

      if (collapsed) savePanel.setAttribute('data-collapsed', '');
      else savePanel.removeAttribute('data-collapsed');

      /* A 0fr row is invisible but still holds a real link. `inert` takes it
         out of the tab order AND the accessibility tree together — the focus
         trap in this drawer already skips [inert] subtrees, so the sign-in
         button stops being something a keyboard can land on while folded.
         visibility:hidden would not do this on its own. */
      if (collapsed) savePanel.setAttribute('inert', '');
      else savePanel.removeAttribute('inert');

      try {
        window.localStorage.setItem(SAVE_COLLAPSED, collapsed ? '1' : '0');
      } catch (error) {}
    }

    if (saveToggle) {
      saveToggle.addEventListener('click', function () {
        setSaveCollapsed(saveToggle.getAttribute('aria-expanded') === 'true');
      });
    }

    /* Restore the choice before the block is ever shown. Someone who folded
       this away does not want it back on the next heart. The block starts
       `hidden`, so applying the state here is silent — a transition on a
       display:none element does not run, and it is already at 0fr by the time
       syncSavePrompt unhides it. */
    try {
      if (window.localStorage.getItem(SAVE_COLLAPSED) === '1') setSaveCollapsed(true);
    } catch (error) {}

    /* The prompt belongs to exactly one state: signed out WITH a list. Signed
       in there is nothing to ask for; signed out with an empty list the
       benefits panel is the more useful thing, and "don't lose your list" is
       not yet a true sentence. */
    function syncSavePrompt(count) {
      if (!savePrompt) return;
      savePrompt.hidden = signedIn || count === 0;
    }

    function render() {
      if (!window.chulaWishlist) return;

      var handles = window.chulaWishlist.items();
      updateCounts();
      syncSavePrompt(handles.length);

      if (!handles.length) {
        /* Signed out and empty: name the state, then offer the account —
           rather than reporting a void, or arguing the case for registering
           before she has anything to protect. */
        if (!signedIn) { renderSaveEmpty(); return; }
        renderEmpty();
        return;
      }

      body.innerHTML = '<p class="chula-wl__loading">' + esc(i18n.loading) + '</p>';

      var requests = handles.map(function (handle) {
        if (cache[handle]) return Promise.resolve(cache[handle]);

        return fetch(root + '/products/' + encodeURIComponent(handle) + '.js')
          .then(function (response) {
            if (!response.ok) throw new Error('missing');
            return response.json();
          })
          .then(function (data) {
            cache[handle] = data;
            return data;
          })
          .catch(function () {
            return null;
          });
      });

      Promise.all(requests).then(function (products) {
        var rows = '';
        var delay = 0;
        var shown = 0;

        products.forEach(function (product, index) {
          if (!product) {
            window.chulaWishlist.remove(handles[index]);
            return;
          }

          shown += 1;

          var image = thumb(product.featured_image);
          var priceLabel = product.price_varies
            ? i18n.from.replace('{price}', money(product.price_min))
            : money(product.price);

          /* A product with one unnamed variant is a one-size piece. That is
             the same detection the old single-variant branch used, kept as
             one rule rather than adding a second test for "One size". */
          var variants = product.variants || [];
          var single = variants.length === 1;
          var oneSize = single && (!variants[0].title || variants[0].title === 'Default Title');

          /* Label by the option that actually VARIES, not by variant.title.
             Chula's catalogue mixes the two shapes: a dress varies by Size
             (XS…XL, one option), while a poncho varies by Color and carries
             a second Size option with the single value "One size". Using
             variant.title on the second shape printed "midnight indigo /
             One size" four times over — the size is the part that does not
             change, so it is the one part not worth showing.

             product.options gives {name, position, values} per option, and
             variant.options is aligned to it by position, so an option with
             more than one value is the one doing the distinguishing. Older
             /products/x.js payloads return options as bare strings; that
             shape falls through to the full title, which is still correct,
             just longer. */
          var opts = product.options || [];
          var varying = [];
          if (opts.length && typeof opts[0] === 'object') {
            opts.forEach(function (o, i) {
              if (o && o.values && o.values.length > 1) varying.push(i);
            });
          }

          /* ONE ROW PER VARYING OPTION, stacked and both visible at once.
             A piece that comes in four colours AND five sizes has twenty
             variants; listing them as twenty combined chips ("carmine /
             M") is unreadable and is what the single-row version did. Two
             short rows, each naming its option, is the whole choice on
             screen with nothing hidden behind a first pick.

             Rows are only built for options that actually vary, so a
             size-only piece still shows exactly one row and a one-size
             piece shows none. */
          var sizes = '';

          if (oneSize) {
            /* Nothing to choose. A permanently "selected" control would
               only read as a stray underline, so this is a plain label. */
            sizes = variants[0].available
              ? '<span class="chula-wl__hint">' + esc(i18n.oneSize) + '</span>'
              : '<button type="button" class="chula-wl__size chula-wl__size--out"' +
                ' data-wl-size aria-pressed="false" data-wl-opt="0"' +
                ' data-value="' + esc(i18n.oneSize) + '">' + esc(i18n.oneSize) + '</button>';
          } else if (varying.length) {
            sizes = varying.map(function (oi) {
              var row = opts[oi].values.map(function (val) {
                /* A value is offered if ANY variant carrying it can be
                   bought. Cross-filtering against the other row's current
                   pick happens in the click handler, where the pick is
                   known — here nothing is chosen yet. */
                var any = variants.some(function (v) {
                  return v.options && v.options[oi] === val && v.available;
                });
                return '<button type="button" class="chula-wl__size' +
                  (any ? '' : ' chula-wl__size--out') +
                  '" data-wl-size aria-pressed="false"' +
                  ' data-wl-opt="' + oi + '"' +
                  ' data-value="' + esc(val) + '">' + esc(val) + '</button>';
              }).join('');

              return '<div class="chula-wl__optrow">' +
                (varying.length > 1
                  ? '<span class="chula-wl__optname">' + esc(opts[oi].name) + '</span>'
                  : '') +
                '<div class="chula-wl__sizes">' + row + '</div>' +
                '</div>';
            }).join('');
          }

          /* One size and in stock is the only case with nothing to choose,
             so its action is live from the start; everything else waits for
             a size. paintAction() below owns every other state. */
          /* A commissioned piece is made to order, so it has no stock and
             nothing to choose here: no "Sold out", no Notify, no size list.
             Hanoian Gate Gown was reading "Sold out" purely because every
             variant is unstocked — a true statement about inventory and a
             false one about the piece, which can be requested today.

             `.crq__cta` on its product page says the same thing in the other
             direction: that branch of product-info.liquid drops the notify
             modal along with the basket, because "tell me when it is back" is
             a sentence about stock. The row follows it.

             The link is the action at every width — the phone additionally
             gets the sheet button below, and the media query shows one or the
             other. */
          var requestPiece = isRequestPiece(product);

          var action = requestPiece
            ? '<a class="chula-wl__action" href="' + esc(loc(product.url)) + '">' +
              esc(i18n.request) + '</a>'
            : !product.available
              ? '<span class="chula-wl__soldout">' + esc(i18n.unavailable) + '</span>' +
                (variants.length ? notifyLink(loc(product.url), variants[0].id) : '')
              : (oneSize && variants[0].available ? addForm(variants[0].id) : hint());

          /* The phone's action. Both this and the inline option rows are
             rendered for EVERY breakpoint and the media query picks one —
             a matchMedia branch here would bake the phone's DOM into a
             desktop window that later crosses 999px, and this list is
             rendered once per open, not per resize. Desktop therefore keeps
             its inline rows untouched by construction.

             Only when there is genuinely something to choose
             (`varying.length`) and the piece can be bought: a one-size item
             already carries a real add form in [data-wl-act] and goes
             straight to the basket, and a sold-out one must keep its
             "Unavailable" + Notify pair rather than offer a basket button. */
          /* A commissioned piece has no basket — its page offers "Request
             this piece" instead — so "Add to basket" is the wrong promise on
             the row even though the sheet it opens gets this right. The row
             cannot tell on its own: `/products/<handle>.js`, which is what
             this drawer fetches, carries no `template_suffix` (verified
             against ci17, an Art piece), and the Art products carry no tag
             that distinguishes them either.

             So the label reads a `request` tag, and until the merchant puts
             that tag on those eight products this branch simply never fires
             and every row keeps saying "Add to basket" exactly as before —
             inert, not broken. Tags are the only field in that payload that
             can carry the answer. */
          /* "Request", not "Request this piece", on the BUTTON. The long form
             is the product page's CTA and belongs on a full-width control; in
             a pill sized to its label it came out 135px, and with Remove
             beside it the pair spanned 194px of a 167px column — Remove was
             pushed outside the card's own border. The text link in
             [data-wl-act] keeps the long form: it has the room, and it reads
             as prose rather than as a button. */
          var quickBuy = requestPiece || (product.available && varying.length)
            ? '<button type="button" class="chula-wl__action chula-wl__quick' +
              (requestPiece ? ' chula-wl__quick--request' : '') + '"' +
              ' data-wl-quick="' + esc(product.handle) + '">' +
              esc(requestPiece ? (i18n.requestShort || i18n.request) : i18n.addToCart) + '</button>'
            : '';

          rows +=
            '<article class="chula-wl__item" style="animation-delay:' + delay.toFixed(2) + 's"' +
            ' data-wl-item data-handle="' + esc(product.handle) + '"' +
            ' data-opts="' + esc(JSON.stringify(varying)) + '"' +
            ' data-variants="' + esc(JSON.stringify(variants.map(function (v) {
              return { id: v.id, o: v.options || [], a: !!v.available };
            }))) + '"' +
            ' data-url="' + esc(loc(product.url)) + '">' +
            '<a class="chula-wl__media" href="' + esc(loc(product.url)) + '">' +
            (image ? '<img src="' + esc(image) + '" alt="" loading="lazy">' : '') +
            '</a>' +
            '<div class="chula-wl__info">' +
            '<div class="chula-wl__line">' +
            '<a class="chula-wl__name" href="' + esc(loc(product.url)) + '">' + esc(product.title) + '</a>' +
            '<span class="chula-wl__price">' + priceLabel + '</span>' +
            '</div>' +
            (sizes && !requestPiece ? '<div class="chula-wl__opts">' + sizes + '</div>' : '') +
            '<div class="chula-wl__actions">' +
            quickBuy +
            '<div data-wl-act>' + action + '</div>' +
            '<button type="button" class="chula-wl__action chula-wl__action--quiet" data-chula-wl-remove="' + esc(product.handle) + '">' + esc(i18n.remove) + '</button>' +
            '</div>' +
            '</div>' +
            '</article>';

          delay += 0.06;
        });

        if (!shown) {
          renderEmpty();
          return;
        }

        /* Since the list can now be built signed out, this line has to tell the
           truth about WHERE it is saved. Signed out it lives in this browser
           only, which is exactly the thing the prompt at the foot of the panel
           asks her to fix — claiming "saved to your account" there would be
           both wrong and a promise the page cannot keep. */
        body.innerHTML =
          '<p class="chula-wl__device">' + esc(signedIn ? i18n.savedAccount : i18n.savedDevice) + '</p>' +
          '<div class="chula-wl__meta">' +
          '<span class="chula-wl__meta-label">' + esc(i18n.yourWishlist) + '</span>' +
          '<span class="chula-wl__meta-count">' + esc((shown === 1 ? i18n.itemOne : i18n.itemOther).replace('{count}', shown)) + '</span>' +
          '</div>' +
          '<div class="chula-wl__items">' + rows + '</div>';
      });
    }

    var hideTimer = null;

    function openDrawer(opener) {
      /* Cancel a pending hide from a close that is still animating out.
         closeDrawer defers `hidden = true` by 800ms to let the exit
         transition finish; reopening inside that window used to let the old
         timer fire afterwards, which set hidden on a drawer that was open —
         is-open present, drawer invisible, nothing clickable. */
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      render();
      drawer.hidden = false;
      if (window.chulaPageLock) window.chulaPageLock.lock();
      else document.documentElement.style.overflow = 'hidden';
      /* Never gate a panel's visibility on requestAnimationFrame — it does
         not fire while a tab is hidden or throttled, which leaves the page
         locked behind a fully transparent overlay. A forced reflow is
         synchronous and the transition still runs. */
      var panel = drawer.querySelector('.chula-wl__panel');
      if (panel) void panel.offsetHeight;
      drawer.classList.add('is-open');

      /* Focus into the panel and hold it there. Without this the drawer opens
         over a page that is still fully tabbable — measured, 51 reachable
         elements behind it — and activeElement never leaves <body>. */
      if (window.chulaFocusTrap) window.chulaFocusTrap.activate(drawer, opener || null);
    }

    function closeDrawer() {
      /* Release before the exit transition: focus goes back to the opener now,
         not 800ms later when the drawer is finally hidden. */
      if (window.chulaFocusTrap) window.chulaFocusTrap.release(drawer);
      drawer.classList.remove('is-open');
      if (window.chulaPageLock) window.chulaPageLock.unlock();
      else document.documentElement.style.overflow = '';
      hideTimer = setTimeout(function () {
        drawer.hidden = true;
        hideTimer = null;
      }, 800);
    }


    /* ── The gallery's progress pill, inside the sheet ──────────────────
       The product page's own bar (sections/main-product.liquid) is built by a
       script scoped to that section and cannot reach in here, and the markup
       QuickBuyModal lifts carries no control of its own once `arrows` is off.
       This is the same mechanism, kept deliberately close to that one so the
       two read alike: a div after the track whose span is sized by the
       visible fraction and moved by the scrolled fraction.

       The sheet's content is replaced on every open and emptied on close, so
       this re-runs per open rather than binding once. `show()` fetches the
       product page first, so the track does not exist yet when the click
       handler returns — hence the short retry, which is what that script does
       for the same reason. Listeners are passive and die with the element. */
    function chulaWlGalleryBar(sheet) {
      var tries = 0;

      var timer = setInterval(function () {
        tries += 1;

        var track = sheet.querySelector('.product-gallery__carousel')
                 || sheet.querySelector('.product-gallery__image-list');

        if (!track) {
          if (tries > 40) clearInterval(timer);
          return;
        }

        clearInterval(timer);

        var old = sheet.querySelector('.chula-gallery-progress');
        if (old) old.remove();

        var bar = document.createElement('div');
        bar.className = 'chula-gallery-progress';
        bar.innerHTML = '<span></span>';
        track.insertAdjacentElement('afterend', bar);

        var thumb = bar.querySelector('span');

        function update() {
          var max = track.scrollWidth - track.clientWidth;

          if (max <= 1) {
            bar.style.visibility = 'hidden';
            return;
          }

          bar.style.visibility = 'visible';

          var ratio = track.clientWidth / track.scrollWidth;

          thumb.style.width = (ratio * 100) + '%';
          thumb.style.transform =
            'translateX(' + ((track.scrollLeft / max) * (100 / ratio - 100)) + '%)';
        }

        update();
        track.addEventListener('scroll', update, { passive: true });

        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(update).observe(track);
        }

        Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
          if (!img.complete) img.addEventListener('load', update, { once: true });
        });
      }, 50);
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      /* Another surface in the shared icon row was clicked: stand down and
         let that item's own opener take over. No preventDefault — the
         handler that opens the target owns that. The active item in this
         panel's own row is an inert <span>, so it cannot reach here. */
      if (
        drawer.classList.contains('is-open') &&
        event.target.closest('[data-chula-panel-nav]')
      ) {
        closeDrawer();
        return;
      }

      if (event.target.closest('[data-chula-wl-open]')) {
        event.preventDefault();

        var sidebar = document.getElementById('sidebar-menu');
        if (sidebar && sidebar.shadowRoot) {
          var sidebarClose = sidebar.shadowRoot.querySelector('[part~="close-button"]');
          if (sidebarClose) sidebarClose.click();
        }

        var wlOpener = event.target.closest('[data-chula-wl-open]');
        setTimeout(function () { openDrawer(wlOpener); }, 60);
        return;
      }

      if (drawer.contains(event.target) && event.target.closest('[data-chula-wl-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      /* The sheet is the theme's OWN <quick-buy-modal> (theme.js:3478), not a
         second variant picker written here: it fetches the product page and
         lifts #quick-buy-content out of it, so the shopper gets the real PDP
         picker — colour swatches included — and anything the merchant changes
         on the product page follows automatically. main-product.liquid renders
         that template unconditionally, so this works with the store's own
         `show_quick_buy` setting left alone (it is off, and it is theirs).

         ONE element is shared by every row; `show()` reads the handle
         attribute at call time, so setting it here is enough. Modal's
         shouldAppendToBody moves it to <body>, which is what keeps it above
         this drawer without a z-index fight. If the custom element has not
         upgraded yet, fall through to the product page rather than dead-end
         the tap. */
      var quickButton = event.target.closest('[data-wl-quick]');
      if (quickButton) {
        event.preventDefault();

        var sheet = document.getElementById('chula-wl-quickbuy');
        var item = quickButton.closest('[data-wl-item]');

        if (!sheet || typeof sheet.show !== 'function') {
          if (item) window.location.href = item.getAttribute('data-url');
          return;
        }

        sheet.setAttribute('handle', quickButton.getAttribute('data-wl-quick'));
        sheet.show();
        chulaWlGalleryBar(sheet);
        return;
      }

      var removeButton = event.target.closest('[data-chula-wl-remove]');
      if (removeButton) {
        event.preventDefault();
        window.chulaWishlist.remove(removeButton.getAttribute('data-chula-wl-remove'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    /* Add to basket, from inside this drawer.
       Prestige opens the cart drawer on a successful add (theme.js:4493,
       driven by the on_success=force_open_drawer field in addForm above) but
       it closes nothing, so the wishlist stayed open behind the cart with
       both page locks held. Hand over the same way the shared icon row does:
       close this, let the cart drawer take the screen.

       Clearing documentElement.style.overflow here cannot disturb the cart
       drawer's own lock: that inline property is only ever set by this file
       and the account drawer — Prestige's dialogs trap focus and never touch
       it — so releasing it restores whatever its stylesheet wanted. */
    document.addEventListener('cart:change', function (event) {
      if (!drawer.classList.contains('is-open')) return;
      if (event.detail && event.detail.baseEvent !== 'variant:add') return;
      closeDrawer();
    });

    document.addEventListener('chula:wishlist-change', function () {
      updateCounts();
      if (drawer.classList.contains('is-open')) render();
    });

    updateCounts();
  })();
